import { useState } from 'react'

type DocsCopyButtonProps =
  | { content: string; slug?: undefined }
  | { content?: undefined; slug: string }

export function DocsCopyButton({ content, slug }: DocsCopyButtonProps) {
  const [copied, setCopied] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleCopy = async () => {
    let text = content
    if (text === undefined && slug) {
      setLoading(true)
      try {
        const res = await fetch(`/docs/${slug}.md`)
        text = await res.text()
      } finally {
        setLoading(false)
      }
    }
    if (!text) return

    navigator.clipboard.writeText(text)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <button
      onClick={handleCopy}
      disabled={loading}
      className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full border border-[var(--color-border)] text-sm text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] hover:border-primary/40 hover:bg-[var(--color-bg-secondary)] transition-all duration-300 ease-brisk hover:-translate-y-0.5 active:scale-[0.97] shrink-0 disabled:opacity-60"
      title="Copy page as Markdown"
    >
      <span className="material-symbols-outlined text-base">
        {copied ? 'check' : 'content_copy'}
      </span>
      {copied ? 'Copied' : 'Copy as Markdown'}
    </button>
  )
}
